import React, { useState } from 'react';
import FilterEditStock from './FilterEditStock';
import AddItemStock from './AddItemStock';
import InventoryUpdate from './InventoryUpdate';

import styles from './InventoryAdd.module.css';

const InventoryAdd = () => {
  // Default to a view that actually renders something.
  const [view, setView] = useState('Add New Item');

  const tabs = ['Add New Item', 'Edit Item', 'Upload Excel'];
  const labels = {
    'Add New Item': 'Add New Stock',
    'Edit Item': 'Edit Stock',
    'Upload Excel': 'Mass Update (Excel)',
  };

  return (
    <div className={styles.container}>
      <div className={styles.menuBar}>
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`${styles.menuBtn} ${view === tab ? styles.active : ''}`}
            onClick={() => setView(tab)}
          >
            {labels[tab]}
          </button>
        ))}
      </div>

      {view === 'Add New Item' && <AddItemStock />}
      {view === 'Edit Item' && <FilterEditStock />}
      {view === 'Upload Excel' && <InventoryUpdate />}
    </div>
  );
};

export default InventoryAdd;